import { render, staticRenderFns } from "./AddCompanyGroupCard.vue?vue&type=template&id=bdcf9516&scoped=true&"
import script from "./AddCompanyGroupCard.vue?vue&type=script&lang=js&"
export * from "./AddCompanyGroupCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcf9516",
  null
  
)

export default component.exports